import { Button } from "@mui/material";
import { RefreshCcw } from "lucide-react";
import React from "react";

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  console.error(error);
  return (
    <div className="h-full w-full flex items-center justify-center flex-col bg-white">
      <div className="text-[18px] mb-6">Some error occurred.</div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => window.location.reload()}
      >
        <RefreshCcw className="mr-2" /> Try again
      </Button>
    </div>
  );
};

export default ErrorFallback;
